<template>
<div>
    <!-- modal -->
    <b-modal id="accountingBooksFormModal" centered size="xl" no-close-on-backdrop ref="accountingBooksFormModal" :title=" $t('accountingBooks.info') +' | '+this.companyName + ' - ' + this.subsidiaryLedgerName" hide-footer @close="clear()">
        <b-row>
            <b-col class="mt-2">
                <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                    <b-tab :title=" $t('accountingBooks.receipt')" active style="width:100%;">
                        <b-card-text>
                            <accounting-books-receipt-list :subsidiaryLedgerId="this.id" :year="this.year" :companyId="companyId" :getAccountingBooksList="getAccountingBooksList"></accounting-books-receipt-list>
                        </b-card-text>
                    </b-tab>
                    <b-tab :title=" $t('accountingBooks.accounts')" style="width:100%;">
                        <b-card-text>
                            <accounting-books-accounts-list :subsidiaryLedgerId="this.id" :getAccountingBooksList="getAccountingBooksList"></accounting-books-accounts-list>
                        </b-card-text>
                    </b-tab>
                    <b-tab :title=" $t('accountingBooks.business_partner')" style="width:100%;">
                        <b-card-text>
                            <business-partner-list :subsidiaryLedgerId="this.id"></business-partner-list>
                        </b-card-text>
                    </b-tab>
                    <b-tab :title=" $t('accountingBooks.accounting_transaction_type')" style="width:100%;">
                        <b-card-text>
                            <accounting-transaction-type-list :subsidiaryLedgerId="this.id" :getAccountingBooksList="getAccountingBooksList"></accounting-transaction-type-list>
                        </b-card-text>
                    </b-tab>
                    <b-tab :title=" $t('accountingBooks.accounting_transaction_doesnt_balanced_entities_report')" style="width:100%;">
                        <b-card-text>
                            <accounting-transaction-doesnt-balanced-entities-report-list :subsidiaryLedgerId="this.id" :getAccountingBooksList="getAccountingBooksList"></accounting-transaction-doesnt-balanced-entities-report-list>
                        </b-card-text>
                    </b-tab>
                    <b-tab :title=" $t('accountingBooks.accounting_transaction_ledger_report')" style="width:100%;">
                        <b-card-text>
                            <accounting-transaction-ledger-report-list :subsidiaryLedgerId="this.id" :getAccountingBooksList="getAccountingBooksList"></accounting-transaction-ledger-report-list>
                        </b-card-text>
                    </b-tab>
                    <!-- STOCK-2875: Yevmiye No Atama Raporu ve Kur Farkı Raporu tabları kaldırıldı (kullanıcı isteği) -->
                    <b-tab :title=" $t('accountingBooks.balance_report')" style="width:100%;">
                        <b-card-text>
                            <accounting-balance-report-list :subsidiaryLedgerId="this.id" :getAccountingBooksList="getAccountingBooksList"></accounting-balance-report-list>
                        </b-card-text>
                    </b-tab>
                    <b-tab :title=" $t('accountingBooks.accounting_transaction_output_vat_control_report')" style="width:100%;">
                        <b-card-text>
                            <accounting-transaction-output-vat-control-report :subsidiaryLedgerId="this.id"></accounting-transaction-output-vat-control-report>
                        </b-card-text>
                    </b-tab>
                    <!-- STOCK-2875: E-Defter tabı kaldırıldı (kullanıcı isteği) -->
                    <b-tab :title=" $t('accountingBooks.doesnt_transfered_records_report')" style="width:100%;">
                        <b-card-text>
                            <accounting-transaction-doesnt-transfered-records-report-list :subsidiaryLedgerId="this.id"></accounting-transaction-doesnt-transfered-records-report-list>
                        </b-card-text>
                    </b-tab>
                    <b-tab :title=" $t('accountingBooks.closing_entries')" style="width:100%;">
                        <b-card-text>
                            <closing-entries-form :subsidiaryLedgerId="this.id"></closing-entries-form>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getAccountingBooksList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            companyName: '',
            subsidiaryLedgerName: '',
            year: null,
            companyId: null
        }
    },
    methods: {
        showInfo(id, companyName, subsidiaryLedgerName, year, companyId) {
            this.companyName = companyName
            this.subsidiaryLedgerName = subsidiaryLedgerName
            this.year = year
            this.companyId = companyId
            this.$refs['accountingBooksFormModal'].show()
            this.id = id
        },
        clear(){
            this.id = 0
            this.companyName = ''
            this.subsidiaryLedgerName = ''
            this.year = null
            this.companyId = null
        }
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
